import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import {
  Card, Form, Button, Radio,
  Input, Upload,
} from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import history from 'utils/history'

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 5,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 12,
    },
  },
}

const tailLayout = {
  wrapperCol: {
    xs: {
      offset: 24,
      span: 24,
    },
    sm: {
      offset: 5,
      span: 12,
    },
  },
}

const FormMitra = ({
  handleSubmit, isEdit, isSubmit,
  handleUpload, imgFile, data,
}) => {
  const [form] = Form.useForm()

  useEffect(() => {
    if (isEdit && data) {
      form.setFieldsValue({
        name: data?.name || '',
        phone_number: data?.contact_number || '',
        website: data?.website || '',
        registration_url: data?.registration_url || '',
        guide_url: data?.guide_url || '',
        branding: data?.brand || '',
        status: data?.status || false,
      })
    }
  }, [data])

  const validateMessages = {
    required: "'${label}' is required!", // eslint-disable-line no-template-curly-in-string
  }

  return (
    <div>
      <div className="btn-primary-wrapper d-flex justify-content-between mb-4">
        <h3 className="title-content mb-0">
          {isEdit ? 'Edit' : 'Add'}
          {' '}
          Mitra
        </h3>
      </div>
      <Card className="pt-4">
        <Form
          {...formItemLayout}
          form={form}
          name="survey"
          onFinish={handleSubmit}
          validateMessages={validateMessages}
        >
          <Form.Item label="Nama" name="name" rules={[{ required: true }]}>
            <Input placeholder="Nama" />
          </Form.Item>

          <Form.Item label="No. Telepon" name="phone_number" rules={[{ required: true }]}>
            <Input placeholder="Nomor Telepon" />
          </Form.Item>

          <Form.Item label="Website" name="website" rules={[{ required: true }]}>
            <Input placeholder="Website" />
          </Form.Item>

          <Form.Item label="Link Pendaftaran" name="registration_url" rules={[{ required: true }]}>
            <Input placeholder="URL Register" />
          </Form.Item>

          <Form.Item label="Link Panduan" name="guide_url" rules={[{ required: true }]}>
            <Input placeholder="URL Panduan" />
          </Form.Item>

          <Form.Item label="Branding" name="branding" rules={[{ required: true }]}>
            <Input placeholder="Branding" />
          </Form.Item>

          <Form.Item
            name="logo_file"
            label="Icon"
            valuePropName="logoFile"
            extra="Size maksimal 1MB"
            getValueFromEvent={handleUpload}
          >
            <Upload
              showUploadList={false}
              beforeUpload={() => false}
            >
              <React.Fragment>
                {imgFile && (
                  <img src={imgFile} className="icon-thumbnail-form" alt="category icon" />
                )}
                <div>
                  <Button icon={<UploadOutlined />}>Click to upload</Button>
                </div>
              </React.Fragment>
            </Upload>
          </Form.Item>

          <Form.Item name="status" label="Status" rules={[{ required: true }]} initialValue="inactive">
            <Radio.Group>
              <Radio value="active">Active</Radio>
              <Radio value="inactive">Inactive</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item {...tailLayout} className="btn-primary-wrapper text-right">
            <Button onClick={() => window.history.back()} className="m-r-10" style={{ display: 'inline-block' }}>Cancel</Button>
            <Button type="primary" loading={isSubmit} htmlType="submit">{isEdit ? 'Submit Change' : 'Create'}</Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  )
}

FormMitra.propTypes = {
  handleSubmit: PropTypes.func,
  isSubmit: PropTypes.bool,
  isEdit: PropTypes.bool,
  handleUpload: PropTypes.func,
  imgFile: PropTypes.any,
  data: PropTypes.object,
}

export default FormMitra
